import React from "react";
import { Box, Container } from "@mui/material";
import BannerSlot from "./marketing/BannerSlot";

export default function AppShell({ children, fullWidth = false, fullWidthBottom = null }) {
  return (
    <Box>
      {/* Content + Sidebar */}
      <Container maxWidth={false} sx={{ pb: 4, maxWidth: 1440, px: { xs: 0, sm: 1.5 } }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 300px" },
            gap: 2,
            alignItems: "start",
            height: "100%",
          }}
        >
          <Box sx={{ pt: 1, mb:1 }}>
            <BannerSlot placement="HEADER" variant="header" />
          </Box>
        </Box>
        {fullWidth ? (
          <Box
            sx={{
              width: "100vw",
              ml: "calc(50% - 50vw)",
              mr: "calc(50% - 50vw)",
            }}
          >
            {children}
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 300px" },
              gap: 2,
              alignItems: "start",
              height: "100%",
            }}
          >
            {/* Main content */}
            <Box>{children}</Box>

            {/* Sidebar banner */}
            <Box
              sx={{
                display: { xs: "none", md: "block" },
                position: { md: "sticky" },
                top:100,
                mt:8
                }}
            >
              <BannerSlot placement="SIDEBAR" variant="sidebar" />
            </Box>
          </Box>
        )}
      </Container>
      {fullWidthBottom}
    </Box>
  );
}
